//選課模式
export enum StepEnterType {
	FSFI = 'FSFI', //先選先贏
	VLUN = 'VLUN', //志願排序
	RAND = 'RAND', //隨機分配
	MIXD = 'MIXD', //混合
}

export const DATE_TIME_FORMATS = {
	YYYY_MM_DD: 'yyyy/MM/dd',
	YYYY_MM_DD_HH_MM: 'yyyy/MM/dd HH:mm',
	HH_MM: 'HH:mm',
}

//階段對象狀態
export enum ScasStepTargetStatus {
	//進行中
	Processing = 'Processing',
	// 即將開始
	ComingSoon = 'ComingSoon',
	// 尚未開始
	NotYet = 'NotYet',
	// 已結束
	Finished = 'Finished',
}

export enum ObserverEvent {
	MyCourse = 'myCourse', //我的課程
	StepOperation = 'stepOperation', //本階段已加選課程
	OperationRecord = 'operationRecord', //操作紀錄
	QueryClassList = 'queryClassList', // 課程列表
}

// 志願加選步驟
export enum VolunteerStep {
	GroupList = 'GroupList', //顯示志願群組列表
	ClassList = 'ClassList', //顯示單一志願群組課程列表
	AdjustVolunteer = 'AdjustVolunteer', //顯示調整志願順序
}

export enum MessageType {
	Success = 'Success',
	Warning = 'Warning',
	Error = 'Error',
	Info = 'Info',
	Confirm = 'Confirm',
}

export enum ElectiveStudyStatus {
	Over = 'Over', //已修超過規定學分
	Equal = 'Equal', //已修等於規定學分
	Insufficient = 'Insufficient', //已修未達規定學分
}
